import AgeSelectorDesktop from 'components/pet-profile/age-selector/desktop';
import { memo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useClickAway } from 'react-use';
import { useNeedCapture } from '../../../../state';
import SelectorButton from '../selector-button';

interface AgeSelectorProps {
  isMobile: boolean;
  petType: 'dog' | 'cat';
}

/**
 * Age Selector component of the NeedCapture component
 */
const AgeSelector: React.FC<AgeSelectorProps> = ({ isMobile, petType }) => {
  const { state, dispatch, onSelectAge } = useNeedCapture();
  const ageSelectorRef = useRef<HTMLDivElement>(null);

  useClickAway(ageSelectorRef, () => {
    if (!isMobile && state.isAgeSelectorOpen)
      dispatch({ type: 'TOGGLE_AGE_SELECTOR' });
  });
  return (
    <div className="flex items-center gap-3 lg:w-1/2">
      <span className="shrink-0">
        <FormattedMessage id={`landingpage:need-capture:age:text:${petType}`} />
      </span>
      <div
        className="relative flex w-full items-center lg:block"
        ref={ageSelectorRef}
      >
        <div className="w-full">
          <SelectorButton
            isOpen={state.isAgeSelectorOpen}
            onClick={() => dispatch({ type: 'TOGGLE_AGE_SELECTOR' })}
          >
            <span className={!state?.selectedAge ? 'italic' : ''}>
              <FormattedMessage
                id={`landingpage:need-capture:age:${
                  state?.selectedAge ?? 'placeholder'
                }`}
              />
            </span>
          </SelectorButton>
        </div>
        {!isMobile && (
          <AgeSelectorDesktop
            isOpen={state.isAgeSelectorOpen}
            selectedOption={state?.selectedAge}
            onSelect={onSelectAge}
          />
        )}
      </div>
      {petType === 'cat' && (
        <FormattedMessage id="landingpage:need-capture:age:text:cat:separator" />
      )}
    </div>
  );
};

export default memo(AgeSelector);
